import { render, staticRenderFns } from "./security-temporary-password-setup.vue?vue&type=template&id=766351d6&"
import script from "./security-temporary-password-setup.vue?vue&type=script&lang=js&"
export * from "./security-temporary-password-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports